import { mockFormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { mockFormField } from '@domgen/dgx-fe-forms/layout';
import { CmsPersonalDetailsForm } from '../../models/cms/cms-personal-details-form.interface';

export const mockCmsPersonalDetailsForm: CmsPersonalDetailsForm = {
  addressFieldset: mockFormOverrideAddressFieldset,
  emailAddressField: mockFormField,
  firstNameField: mockFormField,
  lastNameField: mockFormField,
  telephoneNumberField: mockFormField,
  titleIdField: mockFormField,
};
